import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { ServerhandlerService } from '../serverHandler/serverhandler.service';
//import { AuthenticationService } from '../authentication/Authentication.service';
import { FileUploadResponse } from '../../models/file';
import { FinalizeChunkedUploadRequest } from '../../models/FinalizeChunkedUploadRequest';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private httpClient: HttpClient,
    //private serverHandlerService: ServerhandlerService,
    //private authenticationService: AuthenticationService
  ) {
  }

  public uploadFileChunked(projectId: string, fileName: string, file: File, callbackProgress: (percent: number) => boolean, callbackFinished: (result: FileUploadResponse) => void, callbackError: (error: any) => void) {
    var self = this;
    //if (!self.authenticationService.user) return;

    const chunkSize = 1024 * 1024;
    let fileUuid = Date.now().toString()+"_"+Math.round(Math.random()*10000).toString();

    let chunks: Blob[] = [];

    for( let offset = 0; offset < file.size; offset += chunkSize ){
      const chunk = file.slice( offset, offset + chunkSize );
      chunks.push(chunk);
    }

    self.uploadFilesChunked(projectId, fileName, fileUuid, chunks.length, chunks, 1, callbackProgress, callbackFinished, callbackError);
  }

  private uploadFilesChunked(projectId: string, fileName: string, fileUuid: string, countChunks: number, chunks: Blob[], index: number, callbackProgress: { (percent: number): boolean; (arg0: number): boolean; }, callbackFinished: (result: FileUploadResponse) => void, callbackError: (error: any) => void) {
    var self = this;
    //if (!self.authenticationService.user) return;
    if (chunks.length < 1) {
      self.finalizeFileChunked(projectId, fileName, fileUuid, countChunks, callbackFinished, callbackError);
      return;
    }

    let chunk = chunks.splice(0,1)[0];

    const formData = new FormData();
    formData.append("file", chunk, fileUuid+"_"+index);
    // self.httpClient.post<FileUploadResponse>(self.serverHandlerService.getUrl() + "/" + projectId + "/file/chunkedUpload", formData,
    // self.serverHandlerService.getHttpOptions("NONE")).subscribe(data => {
    //     const result = data as any;
    //     var resultData = result.body as FileUploadResponse;
    //     let percent = Math.round(100 * index / countChunks);
    //     if (callbackProgress)  {
    //       if (callbackProgress(percent)==false) {
    //         self.clearFilesChunked(projectId, fileUuid);
    //         return;
    //       }
    //     }
    //     self.uploadFilesChunked(projectId, fileName, fileUuid, countChunks, chunks, index+1, callbackProgress, callbackFinished, callbackError);
    //   },
    //   error => {
    //   }
    // );
  }

  private clearFilesChunked(projectId: string, fileUuid: string) {
    var self = this;
    //if (!self.authenticationService.user) return;
    // self.httpClient.get<void>(self.serverHandlerService.getUrl() + "/"  +projectId + "/file/clearChunkedUpload/" + fileUuid,
    // self.serverHandlerService.getHttpOptions("NONE")).subscribe(data => {
    //     const result = data as any;
    //   },
    //   error => {
    //   }
    // );
  }

  private finalizeFileChunked(projectId: string, fileName: string, fileUuid: string, countChunks: number, callbackFinished: { (result: FileUploadResponse): void; (arg0: FileUploadResponse): void; }, callbackError: { (error: any): void; (arg0: any): void; }) {
    var self = this;
    var request = new FinalizeChunkedUploadRequest();
    request.fileUuid = fileUuid;
    request.fileName = fileName;
    request.countChunks = countChunks;

    // self.httpClient.post<FileUploadResponse>(self.serverHandlerService.getUrl() +"/" + projectId + "/file/finalizeChunkedUpload", request,
    // self.serverHandlerService.getHttpOptions()).subscribe(data => {
    //     const result = data as any;
    //     var resultData = result.body as FileUploadResponse;
    //     if (callbackFinished) callbackFinished(resultData);
    //   },
    //   error => {
    //     if (callbackError) callbackError(error);
    //   }
    // );
  }

  public uploadChunk(projectId: string, fileName: string, file: Blob, callback: (arg0: FileUploadResponse) => void) {
    var self = this;
    //if (!self.authenticationService.user) return;
    const formData = new FormData();
    formData.append(fileName, file, fileName);
    // this.httpClient.post<FileUploadResponse>(this.serverHandlerService.getUrl() + "/" + projectId + "/file", formData,
    // this.serverHandlerService.getHttpOptions()).subscribe(data => {
    //   const result = data as any;
    //   var resultData = result.body as FileUploadResponse;
    //   if (callback) callback(resultData);
    //   },
    //   error => {
    //   }
    // );
  }


}
